export default function () {
  return {
    planoAcaoCartoes: {
      data: [],
    },
    planoAcaoCartao: {
      attributes: {
        titulo: '',
      },
      relationships: {
      },
    },
  };
}
